import MobileIconUi from 'client/components/core/Sidebar/components/Settings/styles/ui/MobileIconUi'
import React from 'react'
import { OptionWrapper } from 'src/editor/layout/sidebar/settings/option-wrapper'
import { twMerge } from 'tailwind-merge'
import {
  ImageControlStandalone,
  ImageControlStandaloneProps,
} from './image-control-standalone'

type ImageControlProps = ImageControlStandaloneProps & {
  isMobile?: boolean
  className?: string
  labelClassName?: string
  label?: string
}

export const ImageControl = ({
  label = 'settings_styles.background_image.style',
  className,
  labelClassName,
  ...props
}: ImageControlProps) => {
  return (
    <OptionWrapper
      directionRow
      labelClassName={twMerge('text-textPrimary', labelClassName)}
      labelText={label}
      labelIcon={props.isMobile && <MobileIconUi />}
      className={twMerge('', className)}
    >
      <ImageControlStandalone {...props} />
    </OptionWrapper>
  )
}
